/**
 * Hurricane / tropical cyclone tracker config.
 * Auto-generated by hurricane_io.py / run_hurricane_hourly.py — do not edit by hand.
 * Updated: 2026-08-05T08:05Z
 */

export const hurricaneUpdated = "2026-08-05T08:05Z";

/** Currently active (or very recently active) storms */
export const hurricaneActiveStorms = [
  {
    "id": "wp122026",
    "name": "Dolphin",
    "basin": "WP",
    "vmax_kt": 100,
    "mslp_mb": 941,
    "sshws": "Cat3",
    "sshws_label": "Category 3",
    "lat": 25.6,
    "lon": 137.2,
    "latest_time": "2026-08-05T06:00Z",
    "models": [
      "jma"
    ],
    "color": [
      255,
      193,
      64
    ]
  },
  {
    "id": "wp152026",
    "name": "Chan-hom",
    "basin": "WP",
    "vmax_kt": 40,
    "mslp_mb": 998,
    "sshws": "TS",
    "sshws_label": "Tropical Storm",
    "lat": 19.6,
    "lon": 165.7,
    "latest_time": "2026-08-05T06:00Z",
    "models": [
      "jma"
    ],
    "color": [
      0,
      250,
      244
    ]
  },
  {
    "id": "wp142026",
    "name": "Kujira",
    "basin": "WP",
    "vmax_kt": 46,
    "mslp_mb": 996,
    "sshws": "TS",
    "sshws_label": "Tropical Storm",
    "lat": 17.8,
    "lon": 119.1,
    "latest_time": "2026-08-05T06:00Z",
    "models": [
      "jma"
    ],
    "color": [
      0,
      250,
      244
    ]
  },
  {
    "id": "wp942026",
    "name": "Invest",
    "basin": "WP",
    "vmax_kt": 20,
    "mslp_mb": 1002,
    "sshws": "TD",
    "sshws_label": "Tropical Depression",
    "lat": 17.1,
    "lon": 119.5,
    "latest_time": "2026-08-04T12:00Z",
    "models": [],
    "color": [
      94,
      186,
      255
    ]
  },
  {
    "id": "ep072026",
    "name": "Genevieve",
    "basin": "EP",
    "vmax_kt": 35,
    "mslp_mb": 1009,
    "sshws": "TS",
    "sshws_label": "Tropical Storm",
    "lat": 24.6,
    "lon": -138.9,
    "latest_time": "2026-08-02T18:00Z",
    "models": [
      "ecmwf",
      "ukm",
      "gfs",
      "navgem",
      "ofcl"
    ],
    "color": [
      0,
      250,
      244
    ]
  }
];

/** Model toggle metadata (Windy-style) */
export const hurricaneModels = {
  ecmwf: { id: 'ecmwf', label: 'ECMWF', color: [255, 77, 79], techs: ["EMXI", "EMX", "EEMN", "EEMI", "ECMO", "ECMF", "AEMN", "AC00"] },
  ukm:   { id: 'ukm',   label: 'UKM',   color: [82, 196, 26],   techs: ["UKXI", "UKX", "EGRI", "EGRR", "UKMI", "UKM", "UKX2", "EGR2"] },
  jma:   { id: 'jma',   label: 'JMA',   color: [250, 173, 20],   techs: ["JGSI", "JGSM", "JGS2", "JTYM", "JMA", "JMAI"] },
  gfs:   { id: 'gfs',   label: 'GFS',   color: [22, 119, 255],   techs: ["AVNI", "AVNO", "GFSI", "GFSO"] },
  navgem: { id: 'navgem', label: 'NAVGEM', color: [169, 104, 255], techs: ["NVGI", "NVGM", "NAVG"] },
  cwb:   { id: 'cwb',   label: 'CWB',   color: [20, 184, 166],   techs: ["CWB", "CWBI", "CWBM"] },
  ofcl:  { id: 'ofcl',  label: 'Official (NHC/JTWC)', color: [255, 255, 255], techs: ["OFCL", "OFCI", "JTWC", "JTWI"] },
};

/** Saffir–Simpson Hurricane Wind Scale */
export const saffirSimpsonScale = [
  {
    "id": "TD",
    "label": "Tropical Depression",
    "vmin_kt": 0,
    "vmax_kt": 33,
    "color": [
      94,
      186,
      255
    ]
  },
  {
    "id": "TS",
    "label": "Tropical Storm",
    "vmin_kt": 34,
    "vmax_kt": 63,
    "color": [
      0,
      250,
      244
    ]
  },
  {
    "id": "Cat1",
    "label": "Category 1",
    "vmin_kt": 64,
    "vmax_kt": 82,
    "color": [
      255,
      255,
      204
    ]
  },
  {
    "id": "Cat2",
    "label": "Category 2",
    "vmin_kt": 83,
    "vmax_kt": 95,
    "color": [
      255,
      231,
      117
    ]
  },
  {
    "id": "Cat3",
    "label": "Category 3",
    "vmin_kt": 96,
    "vmax_kt": 112,
    "color": [
      255,
      193,
      64
    ]
  },
  {
    "id": "Cat4",
    "label": "Category 4",
    "vmin_kt": 113,
    "vmax_kt": 136,
    "color": [
      255,
      143,
      32
    ]
  },
  {
    "id": "Cat5",
    "label": "Category 5",
    "vmin_kt": 137,
    "vmax_kt": null,
    "color": [
      255,
      96,
      96
    ]
  }
];

export const hurricaneBasePath = '/jsonFiles/hurricanes';
